var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1.16,
    width: 10.11,
    height: 7.14,
    rx: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.89,
    y: 16.02,
    width: 10.11,
    height: 7.14,
    rx: 0.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 10.67,
    width: 10.11,
    height: 12.49,
    rx: 1.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.89,
    y: 1.16,
    width: 10.11,
    height: 12.49,
    rx: 1.18
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard01);
export default __webpack_public_path__ + "static/media/Dashboard_01.d740e61841ac177fdf1f9eb5d62e0f3d.svg";
export { ForwardRef as ReactComponent };